/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets GenderAndEmailAddressDetails from api:
 * /v1/ua/get_gender_email_address
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchGetGenderEmailAddressUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/get_gender_email_address`,
    models.GenderAndEmailAddressDetails
  );
};

/**
 * Post request to path:
 * /v1/ua/modify_email_address
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postModifyEmailAddressUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/modify_email_address`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESModifyEmailAddressRespDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

export { fetchGetGenderEmailAddressUtil, postModifyEmailAddressUtil };
